module.exports = __webpack_public_path__ + "static/media/selectedBoatStopIcon.67e0f55c.png";